import { DSDropdownMenuV2 } from '@elliemae/ds-dropdownmenu';
import { MoreOptionsVert } from '@elliemae/ds-icons';
import { useMemo, useState } from 'react';
import { GridPreferences, useGridPreferences } from './gridPreferences';
import { StyledIconButton } from './styled';

const OPTIONS: Array<{ dsId: keyof GridPreferences; label: string }> = [
  { dsId: 'verticalLines', label: 'Vertical lines' },
  { dsId: 'horizontalLines', label: 'Horizontal lines' },
  { dsId: 'rowBanding', label: 'Show Row Banding' },
  { dsId: 'displaySearchCriteria', label: 'Display Search Criteria' },
];

export const GridSettingsMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { preferences, applySelection } = useGridPreferences();

  const options = useMemo(
    () =>
      // checkbox options require a value as well as a dsId
      OPTIONS.map(({ dsId, label }) => ({
        dsId,
        label,
        value: dsId,
        type: 'checkbox' as const,
      })),
    [],
  );

  // DSDropdownMenuV2 wants selection as a keyed map rather than a list.
  const selectedOptions = useMemo(
    () =>
      OPTIONS.reduce<Record<string, boolean>>((acc, { dsId }) => {
        if (preferences[dsId]) acc[dsId] = true;
        return acc;
      }, {}),
    [preferences],
  );

  return (
    <DSDropdownMenuV2
      isOpened={isOpen}
      options={options}
      selectedOptions={selectedOptions}
      onOptionClick={(nextSelectedOptions: Record<string, unknown>) => {
        applySelection(nextSelectedOptions);
      }}
      onClickOutside={() => setIsOpen(false)}
    >
      <StyledIconButton
        type="button"
        aria-label="Grid display settings"
        aria-expanded={isOpen}
        data-testid="grid-settings-menu"
        onClick={() => setIsOpen((open) => !open)}
      >
        <MoreOptionsVert size="m" />
      </StyledIconButton>
    </DSDropdownMenuV2>
  );
};
